import { Schema as S } from "effect";

/**
 * CardMinimal Schema - Client API Contract
 *
 * Component-focused card representation for card selection UI.
 * Matches client schema at: apps/frontdesk+/client/src/shared/validators-effect/card-operations/card-minimal.schema.ts
 *
 * Field mapping from DocCirrus:
 * - cardType → CardType (capitalized)
 * - cardID → CardHandle
 * - terminalId → CtId
 *
 */
const CardMinimalSchema = S.Struct({
  /** Type of card (e.g., "eGK" for electronic health card) */
  CardType: S.optional(S.String),
  /** Unique identifier required for reading card */
  CardHandle: S.optional(S.String),
  /** Card terminal ID */
  CtId: S.optional(S.String),
  /** Name on the card (if available) */
  CardHolderName: S.optional(S.String),
  /** Insurance number / Krankenversichertennummer (if available) */
  Kvnr: S.optional(S.String),
  /** Certificate expiration date in YYYY-MM-DD format (if available) */
  CertificateExpirationDate: S.optional(S.String),
});

/**
 * GetCardsFromTerminal Response Schema
 *
 * Returns array of CardMinimal objects directly (not wrapped).
 * This matches the client's expectation and implements the component-focused design.
 */
export const GetCardsFromTerminalResponseSchema = S.Array(CardMinimalSchema);

export type GetCardsFromTerminalResponse = S.Schema.Type<typeof GetCardsFromTerminalResponseSchema>;
